module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('Menu', {
    attrs: {
      "mode": "horizontal",
      "theme": "dark",
      "active-name": "1"
    },
    on: {
      "on-select": _vm.selected
    }
  }, [_c('div', {
    staticClass: "layout-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-nav"
  }, [_c('Menu-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-home"
    }
  }), _vm._v("\n        首页\n      ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "2"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-paper"
    }
  }), _vm._v("\n        需求管理\n      ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "3"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-keypad"
    }
  }), _vm._v("\n        产品管理\n      ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "4"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "person"
    }
  }), _vm._v("\n        人员管理\n      ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "5"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "person-stalker"
    }
  }), _vm._v("\n        角色管理\n      ")], 1), _vm._v(" "), _c('Submenu', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "name": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  }), _vm._v("\n          设置\n        ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "61"
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "62"
    }
  }, [_vm._v("退出")])], 2), _vm._v(" "), _c('div', {
    staticClass: "user-name-bar"
  }, [_vm._v(_vm._s(_vm.userName) + "(" + _vm._s(_vm.userTrueName) + ")")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "layout-copy"
  }, [_vm._v("2011-2016 © 艾润物联")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-75548505","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout.vue
// module id = 16
// module chunks = 0